import { getByID } from '@adornis/baseql/operations/mongo.js';
import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import { productDetailPageBuildifyPreset } from '@adornis/buchungsheld-db/_buildify-presets.js';
import { Workshop } from '@adornis/buchungsheld-db/entities/workshop.js';
import '@adornis/buchungsheld-theme/components/tr-button-small.js';
import '@adornis/buchungsheld-theme/components/tr-currency-input.js';
import '@adornis/buchungsheld-theme/components/tr-formfield-wrapper.js';
import '@adornis/buchungsheld-theme/components/tr-input.js';
import '@adornis/buchungsheld-theme/components/tr-tinymce.js';
import '@adornis/buchungsheld-theme/fonts/fonts.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import '@adornis/chemistry/elements/components/x-card.js';
import '@adornis/forms/x-checkbox.js';
import { fullEditorConfig } from '@adornis/html-based-buildify/client/editor/presets/full-editor.js';
import '@adornis/popover/x-dropdown-multiselection.js';
import '@adornis/popover/x-tooltip';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { combineLatest, filter, switchMap } from 'rxjs';
import '../../../../components/bh-admin-product-entry-requirements-overview.js';
import '../../../../components/bh-admin-product-waitinglist-priority-overview.js';
import '../../../../components/bh-admin-teaching-overview';
import { bhBuldifyEditor, bhBuldifyEditorActions } from '../../../../components/bh-buildify-editor.js';
import { provideContextEntity } from '../../../../util.js';
import {
  ProductDetailPageConfig,
  WorkshopAppointmentsConfig,
} from '../../../registration/functional-components/RegistrationProductDetails.js';
import './../../../../components/bh-category-picker.js';
import './../../../../components/bh-product-certificate-picker.js';

@customElement('bh-page-admin-einrichtung-workshop-design')
export class BHPageAdminEinrichtungWorkshopDesign extends BuchungsheldLitElement {
  @property({ attribute: 'workshop-id' }) workshopID = new RXController<string | null>(this, null);
  @property({ attribute: 'institution-id' }) institutionID = new RXController<string | null>(this, null);

  @state() private readonly workshop = new RXController(
    this,
    combineLatest([this.institutionID.observable, this.workshopID.observable]).pipe(
      filter(([_, workshopID]) => Boolean(workshopID)),
      switchMap(async ([institutionID, workshopID]) => {
        return await getByID(
          Workshop,
          workshopID!,
        )({
          _id: 1,
          detailPage: 1,
          translatedDescriptionHTML: { langKey: 1, text: 1 },
          appointments: { _id: 1, start: 1, end: 1, location: 1, name: 1, isNonBlocking: 1 },
        });
      }),
    ),
  );

  override render() {
    const workshop = this.workshop.value;
    const institutionID = this.institutionID.value;
    if (!institutionID || !workshop) return html`<x-loading-state></x-loading-state>`;

    const actions = bhBuldifyEditorActions(this, workshop, 'detailPage', productDetailPageBuildifyPreset);
    for (const action of actions) this.exposeAction(action.icon, action);

    return html`
      <x-flex space="md" ${provideContextEntity(Workshop, { $instance: workshop })}>
        ${bhBuldifyEditor(workshop, 'detailPage', {
          prosemirrorConfig: [
            ...fullEditorConfig(),
            ProductDetailPageConfig('name'),
            ProductDetailPageConfig('translatedDescriptionHTML'),
            WorkshopAppointmentsConfig(workshop._id),
          ],
          defaultDesign: productDetailPageBuildifyPreset,
        })}
      </x-flex>
    `;
  }
}
